import {
  Component,
  EventEmitter,
  OnDestroy,
  OnInit,
  Output,
} from "@angular/core";
import { Router } from "@angular/router";
import * as FileSaver from "file-saver";
import { DashboardService } from "../../../../core/services/dashboard.service";
import { JniToastrService } from "../../../../core/services/jni-toastr.service";
import { OrderSummaryService } from "../../../../core/services/order-summary.service";
import { TableFilterEvent, TableModule } from "primeng/table";
import { CommonModule } from "@angular/common";
import { QR3ReportsDto } from "../../../../core/models/dashboard/qr3ReportsDto";
import { QR3ReportsResponse } from "../../../../core/models/dashboard/qr3ReportsResponse";
import { GetProjectInvoiceReportRequestDto } from "../../../../core/models/orders/getProjectInvoiceReportRequestDto";
import { LoaderService } from "../../../../core/services/loader.service";
import { DateFilterComponent } from "../../../../shared/components/date-filter/date-filter.component";
import { DateFilter } from "../../../../core/models/shared/dateFilter";

@Component({
  selector: "jni-qr3-complete",
  templateUrl: "./qr3-complete.component.html",
  styleUrls: ["./qr3-complete.component.scss"],
  imports: [TableModule, CommonModule, DateFilterComponent],
})
export class Qr3CompleteComponent implements OnInit, OnDestroy {
  qr3List: QR3ReportsDto[] = [];
  qr3Response: QR3ReportsResponse = {} as QR3ReportsResponse;
  @Output() scrollHiddenStatus = new EventEmitter();
  @Output() closeEvent = new EventEmitter();

  filteredQr3List: QR3ReportsDto[] = [];
  filteredDataQr3ListLists: QR3ReportsDto[] = [];
  invoiceDateColumn = "invoiceDate";
  totalMerch = 0;
  totalFreight = 0;
  totalTax = 0;
  totalInvTotal = 0;

  constructor(
    private _dashboardService: DashboardService,
    private _loaderService: LoaderService,
    private _router: Router,
    private _toastr: JniToastrService,
    private _orderSummary: OrderSummaryService
  ) {}

  ngOnInit(): void {
    this.getQR3Reports();
  }

  getQR3Reports() {
    this._loaderService.setLoaderState(true);
    this._dashboardService.getOrdersBilledInvoiced(0).subscribe({
      next: res => {
        if (res.data) {
          this.qr3Response = res.data;
          this.qr3List = res.data.qR3ReportsDto;
          this.filteredQr3List = this.qr3List;
          this.filteredDataQr3ListLists = this.qr3List;
        }
        this._loaderService.setLoaderState(false);
      },
      error: () => {
        this._loaderService.setLoaderState(false);
      },
    });
  }

  redirectToSummary(saleOrderId: string) {
    this._router.navigate(["orders/order-summary/" + saleOrderId]);
  }

  exportQuadReport3() {
    this.exportExcelForFilterData(this.filteredDataQr3ListLists);
  }

  onClose() {
    this.closeEvent.emit();
  }

  b64toBlob(b64Data: string, contentType = "", sliceSize = 512) {
    const byteCharacters = atob(b64Data);
    const byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize);

      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }

      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }

    const blob = new Blob(byteArrays, { type: contentType });
    return blob;
  }

  getInvoiceReport(invoiceId: string) {
    this._loaderService.setLoaderState(true);
    this._dashboardService.getInvoiceReport(invoiceId).subscribe({
      next: res => {
        this._loaderService.setLoaderState(false);
        if (!res.data) {
          this._toastr.error("Error", res.message);
          return;
        }
        const blob = this.b64toBlob(res.data, "application/pdf");
        const blobUrl = URL.createObjectURL(blob);
        window.open(blobUrl);
      },
      error: () => {
        this._loaderService.setLoaderState(false);
        this._toastr.error("Error", "Failed To Load PDF");
      },
    });
  }

  getProjectInvoiceReport(obj: QR3ReportsDto) {
    this._loaderService.setLoaderState(true);
    const reportObject = {
      InvoiceDate: obj.invoiceDate,
      ProjectInvoiceId: obj.invoice,
    } as GetProjectInvoiceReportRequestDto;
    this._orderSummary.getProjectInvoiceReport(reportObject).subscribe({
      next: res => {
        this._loaderService.setLoaderState(false);
        if (res?.data?.reportBase64String) {
          const blob = this.b64toBlob(
            res.data.reportBase64String,
            "application/pdf"
          );
          const blobUrl = URL.createObjectURL(blob);
          window.open(blobUrl);
        } else {
          this._toastr.error("Error", res.message);
          return;
        }
      },
      error: () => {
        this._loaderService.setLoaderState(false);
        this._toastr.error("Error", "Failed To Load PDF");
      },
    });
  }

  exportExcelForFilterData(filterclientlist: QR3ReportsDto[]) {
    const object = filterclientlist.map(datum => {
      return {
        ["Client"]: datum.client,
        ["Job Name"]: datum.jobName,
        ["Merch"]: datum.merch,
        ["Freight"]: datum.freight,
        ["Tax"]: datum.tax,
        ["Inv Total"]: datum.invTotal,
        ["Order"]: datum.order,
        ["Invoice"]: datum.invoice,
        ["Invoice Date"]: datum.invoiceDate,
      };
    });

    import("xlsx").then(xlsx => {
      const worksheet = xlsx.utils.json_to_sheet(object);
      const workbook = { Sheets: { data: worksheet }, SheetNames: ["data"] };
      const excelBuffer: ArrayBuffer = xlsx.write(workbook, {
        bookType: "xlsx",
        type: "array",
      });
      this.saveAsExcelFile(excelBuffer, "Invoices Posted this month");
    });
  }

  saveAsExcelFile(buffer: ArrayBuffer, fileName: string): void {
    const EXCEL_TYPE =
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
    const EXCEL_EXTENSION = ".xlsx";
    const data: Blob = new Blob([buffer], {
      type: EXCEL_TYPE,
    });
    FileSaver.saveAs(
      data,
      fileName + "_export_" + new Date().getTime() + EXCEL_EXTENSION
    );
  }

  ngOnDestroy(): void {
    this.scrollHiddenStatus.emit();
  }

  applyFilter(event: QR3ReportsDto[] | DateFilter) {
    if (Array.isArray(event)) {
      this.filteredQr3List = event;
    }
  }

  clearFilter(event: QR3ReportsDto[] | DateFilter) {
    if (Array.isArray(event)) {
      this.filteredQr3List = event;
    }
  }

  onFilter(event: TableFilterEvent) {
    if (event?.filters && event?.filteredValue?.length > 0) {
      this.filteredDataQr3ListLists = event.filteredValue;
    } else {
      this.filteredDataQr3ListLists = this.filteredQr3List;
    }

    // As per the ticket 12162 totals will show on filters
    this.totalMerch = this.filteredDataQr3ListLists.reduce(
      (total, charge) => total + charge.merch,
      0
    );

    this.totalFreight = this.filteredDataQr3ListLists.reduce(
      (total, charge) => total + charge.freight,
      0
    );

    this.totalTax = this.filteredDataQr3ListLists.reduce(
      (total, charge) => total + charge.tax,
      0
    );

    this.totalInvTotal = this.filteredDataQr3ListLists.reduce(
      (total, charge) => total + charge.invTotal,
      0
    );
  }
}
